export enum AuthenticationTypeFlag {
    EADM_NATIVE = 1,
    EADM_NATIVE_SMS = 2,
    AAD_FEDERATION = 4,
    ID_PORTEN = 8,
    TELIA_FINLAND = 16,
    GOOGLE = 32,
    GRAND_ID_BANKID_SE = 64,
    CUSTOM_SAML = 128,
}
